/** Leading or trailing whitespace on a stored param value (label string or text caption). */
export function hasOuterWhitespace(value: any): boolean {
  if (typeof value === 'string') {
    return value.length > 0 && value.trim() !== value;
  }
  if (value && typeof value === 'object' && typeof value.caption === 'string') {
    return hasOuterWhitespace(value.caption);
  }
  return false;
}

export function trimParamValue(value: any): any {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (value && typeof value === 'object' && typeof value.caption === 'string') {
    return { ...value, caption: value.caption.trim() };
  }
  return value;
}

export function parseParamCodeList(raw: string): string[] {
  return (raw || '')
    .split(',')
    .map(code => code.trim())
    .filter(code => !!code);
}

export function selectTagCodes(tags?: Array<{ code?: string }>): string[] {
  return (tags || []).map(tag => String(tag?.code ?? ''));
}

export function isBlankSelectValue(value: any): boolean {
  return value == null || value === '';
}

/** Stored SELECT value is non-empty and not one of the configured tag codes. */
export function isUnmatchedSelectValue(value: any, tags?: Array<{ code?: string }>): boolean {
  if (isBlankSelectValue(value)) {
    return false;
  }
  return !selectTagCodes(tags).includes(String(value));
}
